import { render, staticRenderFns } from "./SendButton.vue?vue&type=template&id=40028027&scoped=true&"
import script from "./SendButton.vue?vue&type=script&lang=js&"
export * from "./SendButton.vue?vue&type=script&lang=js&"
import style0 from "./SendButton.vue?vue&type=style&index=0&id=40028027&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40028027",
  null
  
)

export default component.exports